module.exports = __webpack_public_path__ + "static/media/message-transparent.76b8a7c4.svg";